export function isLocalhost() {
    return window.location.hostname === "localhost";
}
export function isDev() {
    return (
        window.location.hostname === "dev.sentinelfertigation.com" ||
        window.location.hostname === "grow-dev.sentinelag.tech"
    );
}
export function isProd() {
    return (
        window.location.hostname === "sentinelfertigation.com" ||
        window.location.hostname === "grow.sentinelag.tech"
    );
}
